<div class="page outlet" *ngIf="user">
  <div class="row mt-3">
    <div class="col-8 pt-1 h3 text-primary">
      Account Info
    </div>
    <div class="col-4 text-end">
      <button *ngIf="!edit" class="btn btn-link" (click)="toggleEdit()">
        <fa-icon [icon]="faPencilAlt" transform="grow-5"></fa-icon>
      </button>
    </div>
  </div>

  <hr class="mt-1 mb-2">

  <ng-container *ngIf="!edit; else editForm">

    <div class="row mb-3">
      <div class="col">
        <label for="firstName" class="form-text">First Name</label>
        <div id="firstName" class="fs-4">{{user.firstName}}</div>
      </div>
      <div class="col">
        <label for="lastName" class="form-text">Last Name</label>
        <div id="lastName" class="fs-4">{{user.lastName}}</div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col">
        <label for="phoneNumber" class="form-text">Primary Phone Number</label>
        <div id="phoneNumber" class="fs-4">{{user.phoneNumber}}</div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col">
        <label for="address" class="form-text">Street Address</label>
        <div id="address" class="fs-4">{{user.address?.streetAddress}}</div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col">
        <label for="city" class="form-text">City</label>
        <div id="city" class="fs-4">{{user.address?.city}}</div>
      </div>
      <div class="col-2">
        <label for="state" class="form-text">State</label>
        <div id="state" class="fs-4">{{user.address?.state}}</div>
      </div>
      <div class="col-4">
        <label for="zip" class="form-text">Zip Code</label>
        <div id="zip" class="fs-4">{{user.address?.zipCode}}</div>
      </div>
    </div>

  </ng-container>

  <ng-template #editForm>
    <ua-account-info-form (saveClicked)="save()"
                          (cancelClicked)="cancel()"></ua-account-info-form>
  </ng-template>

</div>
